module.exports = __webpack_public_path__ + "static/media/lc_nov1.90ef6470.png";